import React from 'react';
import Select from 'react-select';
import axios from 'axios';
import AxiosConfig from '../../../utilities/AxiosConfig';
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import moment from 'moment';

interface IProps {
    clientId: string | number;
    userId: string;
    portalClientPK: string | number;
    changeCallback: Function
}

const QuerySelect: React.FC<IProps> = (props: IProps) => {
    const [loading, setLoading] = React.useState(false);
    const [queryTypes, setQueryTypes] = React.useState([]);
    const [selectedQueryTypes, setSelectedQueryTypes] = React.useState([]);
    const [typeList, setTypeList] = React.useState({} as any);
    const [originalValues, setOriginalValues] = React.useState([] as Array<number>);
    const [clientValues, setClientValues] = React.useState({} as any);

    React.useEffect(() => {
        getAllTypes();
        // eslint-disable-next-line 
    }, [props.clientId])

    const getAllTypes = () => {
        setLoading(true);
        let req1 = axios.get(`${process.env.REACT_APP_API_URL}/api/GetClientQueryTypes?clientId=${props.clientId}`, AxiosConfig.configValue("min"));
        let req2 = axios.get(process.env.REACT_APP_API_URL + "/api/GetTicketQueryTypes", AxiosConfig.configValue("min"));
        axios.all([req1, req2])
        .then(axios.spread((...responses) => {
            //console.log(responses);
            if(responses[0]){
                let keylist: any = {};
                let initialValuesKeyList: any = {};
                responses[1].data.forEach((item: any) => {
                    initialValuesKeyList[item.PortalQueryTypeId] = item;
                    keylist[item.PortalQueryTypeId] = item;
                });
                let clientVals: any = {};
                let initialValues = responses[0].data.map((item: any) => {
                    clientVals[item.PortalQueryTypeId] = item;
                    return({label: keylist[item.PortalQueryTypeId]?.PortalQueryTypeName, value: item.PortalQueryTypeId});
                });
                //console.log("Client Values", clientVals);
                setClientValues(clientVals);
                setTypeList(initialValuesKeyList);
                setSelectedQueryTypes(initialValues);
                setOriginalValues(initialValues.map((item: any): number => item.value));
            }
            let ddList = responses[1].data.map((item: any) => ({ value: item.PortalQueryTypeId, label: item.PortalQueryTypeName }));
            setQueryTypes(ddList);
        })).catch((errors: any) => {
            //console.log(errors);
        }).finally(() => { setLoading(false) })
    }

    const createRequestList = (selectedQueryTypes2: any) => {
        if(originalValues || selectedQueryTypes2){
            let editRequests: any = [];
            originalValues.forEach((val: number) => {
                let index = selectedQueryTypes2?.findIndex((item: any) => item.value === val);
                let body: any = clientValues[val];
                if(index === -1 && body) {
                    let requestBody = {
                        ...body,
                        PortalClientPK: props.portalClientPK,
                        ModifiedBy: props.userId,
                        DeletedBy: props.userId,
                        DeletedDateUtc: moment().toDate().toISOString()
                    };
                    editRequests.push(requestBody);
                }
            });

            selectedQueryTypes2.forEach((selection: any) => {
                if(!originalValues.includes(selection.value)){
                    let body = {...typeList[selection.value]};
                    if(body){
                        let requestBody = {
                            ...body,
                            ModifiedBy: props.userId,
                            PortalClientQueryTypeId: 0, // must be 0 when adding
                            PortalClientPK: props.portalClientPK, // Comes from EditClient.tsx
                        }
                        editRequests.push(requestBody);
                    }
                }
            });
            //console.log("Calling Change Callback", editRequests);
            props.changeCallback(editRequests);
        }
    }

    const handleChange = (selection: any) => {
        //console.log("Selection", selection);
        setSelectedQueryTypes(selection);
        createRequestList(selection || []);
    }

    return(
        <div className="w-100 d-flex flex-row justify-content-between align-items-center pb-5 mb-5">
            <Select 
                className="w-100"
                options={queryTypes || []}
                isMulti
                value={selectedQueryTypes}
                onChange={handleChange}
                isDisabled={loading}
            />
        </div>
    );
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userName
})

export default connect(mapStateToProps)(QuerySelect);